export function TMap() {
    return new Promise(function(resolve, reject) {
      window.init = function() {
        resolve(qq)
      }
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://map.qq.com/api/js?v=2.exp&callback=init&key=NK2BZ-2E5KX-HIX4X-7U55S-E745J-SQBOP'
      script.onerror = reject
      document.head.appendChild(script)
    })
  }


// WEBPACK FOOTER //
// ./src/api/parking.js